(() => {
  const MOBILE_MQ = '(max-width: 767px)';
  const BTN_SELECTOR = '.m-collapsible--button';

  // Extra ruimte boven de tabtitel (pas dit aan)
  const EXTRA_GAP = 100;

  const isMobile = () => window.matchMedia(MOBILE_MQ).matches;
  const reducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getHeaderEl = () =>
    document.querySelector('header.m-header') ||
    document.querySelector('.m-header') ||
    document.querySelector('header') ||
    null;

  const getHeaderHeight = () => {
    const header = getHeaderEl();
    if (!header) return 0;

    const pos = getComputedStyle(header).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;

    return Math.ceil(header.getBoundingClientRect().height);
  };

  const scrollToTop = (top, behavior) => {
    window.scrollTo({ top, behavior });
  };

  // Wacht tot layout stabiel is, scroll 1x smooth, daarna 1x stille micro-correctie.
  const scrollPerfect = (btn, maxMs = 700) => {
    const start = performance.now();

    let lastTarget = null;
    let stableFrames = 0;

    // Belangrijk: header kan tijdens scroll groter worden (reveal). We nemen MAX.
    let headerMax = getHeaderHeight();

    const calcTarget = () => {
      headerMax = Math.max(headerMax, getHeaderHeight());
      const offset = headerMax + EXTRA_GAP;

      return Math.round(window.scrollY + btn.getBoundingClientRect().top - offset);
    };

    const waitStable = () => {
      if (!document.contains(btn)) return;

      const target = calcTarget();

      if (lastTarget !== null && Math.abs(target - lastTarget) <= 1) stableFrames++;
      else stableFrames = 0;

      lastTarget = target;

      // 3 frames stabiel = klaar
      if (stableFrames >= 3 || performance.now() - start > maxMs) {
        const behavior = reducedMotion() ? 'auto' : 'smooth';
        scrollToTop(target, behavior);

        // Micro-correctie nadat scroll “klaar” is (idle detect)
        settleAndCorrect(btn);
        return;
      }

      requestAnimationFrame(waitStable);
    };

    const settleAndCorrect = (btnEl) => {
      let t;
      const onScroll = () => {
        clearTimeout(t);
        t = setTimeout(() => {
          window.removeEventListener('scroll', onScroll, { capture: true });

          if (!document.contains(btnEl)) return;

          // Recalc met actuele (mogelijk uitgeklapte) headerhoogte
          headerMax = Math.max(headerMax, getHeaderHeight());
          const offset = headerMax + EXTRA_GAP;
          const finalTarget = Math.round(
            window.scrollY + btnEl.getBoundingClientRect().top - offset
          );

          // Alleen corrigeren als het echt nodig is (voorkomt “hikken”)
          if (Math.abs(finalTarget - window.scrollY) > 2) {
            // stille correctie
            scrollToTop(finalTarget, 'auto');
          }
        }, 140);
      };

      window.addEventListener('scroll', onScroll, { capture: true, passive: true });
      onScroll(); // start idle timer
    };

    requestAnimationFrame(waitStable);
  };

  const handler = (e) => {
    if (!isMobile()) return;

    const btn = e.target.closest(BTN_SELECTOR);
    if (!btn) return;

    // Theme eerst laten togglen, daarna pas meten/scrollen
    setTimeout(() => scrollPerfect(btn), 0);
  };

  ['pointerup', 'touchend', 'click'].forEach((evt) => {
    document.addEventListener(evt, handler, true);
  });
})();